import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FaceId as FaceIdContainer } from '@telavita-core/react-faceid'
import * as routes from '../../settings/_routesSettings'
import * as actions from '../../redux/actions'
import { apiEndpoints } from 'settings/_apiSettings'
import { history } from 'routers/AppRouter'

class FaceId extends Component {
  onSuccess = () => {
    history.push(routes.DASHBOARD)
  }

  onError = async() => {
    this.props.onLogout()
  }

  render() {
    const { token } = this.props
    return (
      <FaceIdContainer
        title="Reconhecimento facial"
        endpoint={apiEndpoints.PERSON_FACE_ID}
        successEvent={this.onSuccess}
        fallbackAction={this.onError}
        token={`Bearer ${token}`}
      />
    )
  }
}

const mapStateToProps = state => {
  return ({ token: state.auth?.userToken || null })
}

const mapDispatchToProps = dispatch => {
  return { onLogout: () => dispatch(actions.authLogout()) }
}

export default connect(mapStateToProps, mapDispatchToProps)(FaceId)
